import { useEffect, useState } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import Textarea from "../../../form/Textarea";
import { toast } from "react-toastify";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  organizationAddEdit,
  organizationDetails,
} from "../../../../services/organizationService";
import AvatarUpload from "../../../common/AvatarUpload";
import { initialsValue } from "../../../../helpers";
import UrlInput from "../../../form/UrlInput";
import IconSelector from "../../../form/iconSelector/IconSelector";
import Tabs from "../../../elements/Tabs";

const validation = {
  name: { required: true, message: "Name is required" },
};

function FormComponent({
  getResponse = () => {},
  close = () => {},
  data,
  lang,
}) {
  const queryClient = useQueryClient();

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: validation,
    // initialState: { socialMedia: [{ name: "", icon: "", url: "" }] },
  });

  const { data: details } = useQuery({
    queryKey: ["details", data?._id],
    queryFn: async () => {
      const res = await organizationDetails({ id: data?._id });
      return res;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ["details", data?._id] });
    };
  }, []);

  useEffect(() => {
    if (details?.data?._id) {
      if (details?.status === 200) {
        const value = {
          ...details?.data,
          name: details?.data?.name?.[lang] || "",
          description: details?.data?.description?.[lang] || "",
          // bio: details?.data?.bio?.[lang] || "",
          logo: details?.data?.logo?.url,
        };
        delete value?._id;
        if (
          value &&
          typeof value === "object" &&
          Object.keys(value)?.length > 0
        ) {
          setFieldsValue(value);
        }
      }
    }
  }, [details?.data?._id, lang]);

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
        name: { ...details?.data?.name, [lang]: val?.name },
        description: {
          ...details?.data?.description,
          [lang]: val?.description,
        },
        ...(data?._id && { id: data?._id }),
      };

      return await organizationAddEdit(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        getResponse(res);
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-2 gap-x-4 gap-y-4">
        <div className="col-span-2 px-6 flex items-center justify-center relative">
          <AvatarUpload
            src={
              values?.logo instanceof File
                ? URL.createObjectURL(values?.logo)
                : values?.logo
            }
            onChange={(file) => {
              handleChange({ target: { name: "logo", value: file } });
            }}
            alt="profile"
            initial={initialsValue(details?.name)}
          />
        </div>
        <div className="relative col-span-2">
          <Input
            label="Name"
            inputPlaceholder={"Enter Name"}
            inputName="name"
            value={values?.name || ""}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>
        {/* <div className="relative">
          <Input
            label="Email"
            inputType="email"
            inputPlaceholder={"Enter Email"}
            inputName="contactEmail"
            value={values?.contactEmail || ""}
            onChange={handleChange}
            {...formValidate(errors, "contactEmail")}
          />
        </div>
        <div className="col-span-2">
          <UrlInput
            label="Website"
            name={"website"}
            value={values?.website}
            onChange={(e) => {
              console.log(e);
              handleChange(e);
            }}
          />
        </div> */}
        <div className="col-span-2">
          <Textarea
            label="Description"
            inputName={"description"}
            inputValue={values?.description || ""}
            onChange={handleChange}
          />
        </div>
        {/* <div className="col-span-2">
          <Textarea label="Bio" inputName={"bio"} onChange={handleChange} />
        </div>
        <div className="col-span-2 space-y-3">
          <div className="text-xs font-medium text-text-disabled mb-1 font-CanelaDeck">
            Add social media
          </div>
          {values?.socialMedia?.map((social, i) => (
            <div
              key={i?.toString()}
              className="grid grid-cols-2 gap-4 bg-slate-50 rounded-lg p-4"
            >
              <div className="relative">
                <Input
                  label="Name"
                  inputPlaceholder={"Enter Name"}
                  inputName="name"
                  value={social?.name || ""}
                  onChange={(e) => {
                    setFieldsValue({
                      socialMedia: values?.socialMedia?.map((item, index) =>
                        index === i ? { ...item, name: e.target.value } : item
                      ),
                    });
                  }}
                />
              </div>
              <div className="relative">
                <UrlInput
                  label="Website"
                  value={social?.url}
                  onChange={(e) => {
                    setFieldsValue({
                      socialMedia: values?.socialMedia?.map((item, index) =>
                        index === i ? { ...item, url: e.target.value } : item
                      ),
                    });
                  }}
                />
              </div>
              <div className="relative">
                <IconSelector
                  label={"Icon"}
                  value={social?.icon}
                  onChange={(val) => {
                    setFieldsValue({
                      socialMedia: values?.socialMedia?.map((item, index) =>
                        index === i ? { ...item, icon: val } : item
                      ),
                    });
                  }}
                />
              </div>
            </div>
          ))}
          <div>
            <Button
              buttonLabel={"Add more social media"}
              variant="secondary"
              buttonFunction={() => {
                setFieldsValue({
                  socialMedia: [
                    ...values?.socialMedia,
                    { name: "", url: "", icon: "" },
                  ],
                });
              }}
            />
          </div>
        </div> */}
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save Organization"}
            variant="secondary"
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            variant="primary"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
}

const ManageOrganization = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const tabs = [
    {
      label: "English",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"en"}
        />
      ),
    },
    {
      label: "Spanish",
      content: (
        <FormComponent
          getResponse={getResponse}
          close={close}
          data={data}
          lang={"es"}
        />
      ),
    },
  ];

  return (
    <div className="h-full p-4">
      <Tabs
        items={tabs}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
        contentClass={"pb-8"}
      />
    </div>
  );
};

export default ManageOrganization;
